import React from "react";

const AnimalWelfare = () => {
  return <div>Animal Welfare</div>;
};

export default AnimalWelfare;
